import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

const exportToExcel = async (filteredRequests) => {
  try {
    if (!filteredRequests || filteredRequests.length === 0) {
      console.error("No data available to export");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Requested Items");

    const columns = [
      { header: "Request ID", key: "requestId", width: 20 },
      { header: "Heading", key: "heading", width: 20 },
      { header: "Sub Heading", key: "subHeading", width: 20 },
      { header: "Category", key: "category", width: 20 },
      { header: "Description", key: "description", width: 30 },
      { header: "Quantity", key: "quantity", width: 15 },
      { header: "Unit", key: "unit", width: 15 },
      { header: "Status", key: "status", width: 15 },
      { header: "Date", key: "date", width: 20 },
    ];

    worksheet.columns = columns;

    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.height = 30;

    assignBackgroundColorToRow(headerRow, "FF4472C4");

    for (const request of filteredRequests) {
      const timestamp = request.timestamp || request.id || Date.now();
      const formattedDate = formatTimestampToDate(Number(timestamp));

      if (Array.isArray(request.items) && request.items.length > 0) {
        for (const item of request.items) {
          const rowData = {
            requestId: request.id,
            heading: item.heading || "Not provided",
            subHeading: item.subHeading || "Not provided",
            category: item.category || "Not provided",
            description: item.description || "Not provided",
            quantity: item.quantity || "0",
            unit: item.unit || "Not provided",
            status: item.status || request?.requestHistory?.[request.id]?.status || "Unknown",
            date: formattedDate,
          };

          const row = worksheet.addRow(rowData);
          assignBackgroundColorToRow(row, "FFD9E1F2");
        }
      } else {
        // If no items present, still create one row for tracking
        const rowData = {
          requestId: request.id,
          heading: "No Items",
          subHeading: "",
          category: "",
          description: "",
          quantity: "",
          unit: "",
          status: request?.requestHistory?.[request.id]?.status || "Unknown",
          date: formattedDate,
        };
        const row = worksheet.addRow(rowData);
        assignBackgroundColorToRow(row, "FFFFC7CE"); // Light red for missing items
      }
    }

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.value) {
          maxLength = Math.max(maxLength, cell.value.toString().length);
        }
      });
      column.width = Math.max(Math.min(maxLength + 2, 50), 15);
    });

    worksheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: columns.length },
    };

    worksheet.views = [{ state: "frozen", xSplit: 0, ySplit: 1, activeCell: "A2" }];

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `Requested_Items_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }

  function assignBackgroundColorToRow(row, color) {
    row.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: color },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "left",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  }
};

export default exportToExcel;
